"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalCard = exports.CardStyle = exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  box-shadow: ", ";\n  padding: 40px ", ";\n  border-top: 2px solid ", ";\n  font-family: ", ";\n"], ["\n  background: ", ";\n  box-shadow: ", ";\n  padding: 40px ", ";\n  border-top: 2px solid ", ";\n  font-family: ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  border-radius: 8px;\n  display: flex;\n  background: ", ";\n  box-sizing: border-box;\n  justify-content: space-between;\n  overflow: hidden;\n  ", ";\n"], ["\n  border-radius: 8px;\n  display: flex;\n  background: ", ";\n  box-sizing: border-box;\n  justify-content: space-between;\n  overflow: hidden;\n  ", ";\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 0;\n  border-radius: 4px;\n  ", "\n"], ["\n  ", "\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 0;\n  border-radius: 4px;\n  ", "\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n        border-top: 2px solid ", ";\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;"], ["\n        border-top: 2px solid ", ";\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;"]),
    _templateObject5 = _taggedTemplateLiteral(["border-top: none;"], ["border-top: none;"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n"], ["\n  flex-grow: 1;\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: ", ";\n  position: relative;\n"], ["\n  width: 100%;\n  height: ", ";\n  position: relative;\n"]),
    _templateObject9 = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 18px;\n  color: ", ";\n"], ["\n  display: block;\n  font-size: 18px;\n  color: ", ";\n"]),
    _templateObject10 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CardStyle = (0, _styledComponents.css)(_templateObject, _buoyTheme.colors.white, _buoyTheme.constants.boxShadow, function (props) {
  return props.inColumn ? "60px" : "32px";
}, function (props) {
  return props.borderColor ? _buoyTheme.colors[props.borderColor] : _buoyTheme.colors.primary;
}, _buoyTheme.fontFamily);

var HorizontalCard = _styledComponents2.default.div.withConfig({
  displayName: "Card__HorizontalCard",
  componentId: "sc-180mv0h-0"
})(_templateObject2, _buoyTheme.colors.white, function (props) {
  return props.showShadow && "box-shadow: " + _buoyTheme.constants.boxShadow(props);
});

var CardContainer = _styledComponents2.default.div.withConfig({
  displayName: "Card__CardContainer",
  componentId: "sc-180mv0h-1"
})(_templateObject3, CardStyle, function (props) {
  return !props.heroImg && props.borderColor ? (0, _styledComponents.css)(_templateObject4, props.borderColor) : (0, _styledComponents.css)(_templateObject5);
});

var CardContent = _styledComponents2.default.div.withConfig({
  displayName: "Card__CardContent",
  componentId: "sc-180mv0h-2"
})(_templateObject6);

var HeroImg = _styledComponents2.default.img.withConfig({
  displayName: "Card__HeroImg",
  componentId: "sc-180mv0h-3"
})(_templateObject7);

var HeroImgWrapper = _styledComponents2.default.div.withConfig({
  displayName: "Card__HeroImgWrapper",
  componentId: "sc-180mv0h-4"
})(_templateObject8, function (props) {
  return props.height;
});

var HeroText = _styledComponents2.default.span.withConfig({
  displayName: "Card__HeroText",
  componentId: "sc-180mv0h-5"
})(_templateObject9, function (props) {
  return _buoyTheme.colors[props.color];
});

var HeroTextWrapper = _styledComponents2.default.div.withConfig({
  displayName: "Card__HeroTextWrapper",
  componentId: "sc-180mv0h-6"
})(_templateObject10);

var Card = function Card(props) {
  return _react2.default.createElement(
    CardContainer,
    props,
    props.heroImg && _react2.default.createElement(
      HeroImgWrapper,
      { height: props.heroHeight },
      _react2.default.createElement(HeroImg, { src: props.heroImg }),
      props.heroText && _react2.default.createElement(
        HeroTextWrapper,
        null,
        _react2.default.createElement(
          HeroText,
          { color: props.heroTextColor },
          props.heroText
        )
      )
    ),
    _react2.default.createElement(
      CardContent,
      null,
      props.children
    )
  );
};

Card.propTypes = {
  heroImg: _propTypes2.default.string,
  heroText: _propTypes2.default.string,
  heroHeight: _propTypes2.default.string,
  heroTextColor: _propTypes2.default.string,
  inColumn: _propTypes2.default.bool,
  borderColor: _propTypes2.default.string
};

Card.defaultProps = {
  heroHeight: "200px",
  heroTextColor: "white"
};

exports.default = Card;
exports.CardStyle = CardStyle;
exports.HorizontalCard = HorizontalCard;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-card/dist/components/Card.js
// module id = 146
// module chunks = 168707334958949